/**
 * Per-follow "seen" snapshot stored under `data.watchlistScoreSeen` on a `savedCompany#*`
 * UserState item — same mechanics as watchlist-seen-snapshot.ts, but for the employer score
 * instead of open roles. Baseline for the Watchlist's "score changed since your last visit"
 * badge: the card diffs the live score against `employerScore` here, then the snapshot
 * advances to the current score once the delta has been shown.
 */
export interface WatchlistScoreSeenSnapshot {
  at: number;
  employerScore: number | null;
}

export function parseWatchlistScoreSeen(value: unknown): WatchlistScoreSeenSnapshot | null {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) return null;
  const record = value as Record<string, unknown>;
  if (typeof record.at !== 'number' || !Number.isFinite(record.at) || record.at <= 0) return null;
  if (record.employerScore !== null && typeof record.employerScore !== 'number') return null;
  return { at: record.at, employerScore: record.employerScore ?? null };
}

export function buildWatchlistScoreSeen(employerScore: number | null, now: number): WatchlistScoreSeenSnapshot {
  return { at: now, employerScore };
}
